import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <path
      fill="#27272C"
      fillRule="evenodd"
      d="M14.94 8.94a1.5 1.5 0 0 1 2.12 0L28.122 20l-11.06 11.06a1.5 1.5 0 0 1-2.122-2.12L23.88 20l-8.94-8.94a1.5 1.5 0 0 1 0-2.12Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrowRight;
